import { ReferenceField, TextField } from "react-admin";
import * as React from "react";
import PropTypes from "prop-types";
import { getSecureRandom } from "../../../Helper/random";

const RequestStatusField = ({ source = "requestStatus", label, record, reference = "requeststatusinfo/reference" }) => {
  return (
    <ReferenceField
      key={getSecureRandom()}
      label={label}
      source={source}
      record={record}
      link={false}
      reference={reference}
    >
      <TextField source="displayName" style={{ color: "#cc0000" }} />
    </ReferenceField>
  );
};

RequestStatusField.propTypes = {
  record: PropTypes.any,
  label: PropTypes.string,
  source: PropTypes.string,
};

export default RequestStatusField;
